import { JSX, memo, useState } from 'react'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Layout from '@/components/layout.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Lister from './lister'
// eslint-disable-next-line @typescript-eslint/naming-convention
import League from './league'




export enum TOptions {
	lister = '所有项目',
	league = '项目分组',

}

function main (props: { tab: TOptions }): JSX.Element
{
	if (props.tab === TOptions.lister)
	{
		return <Lister />

	}

	if (props.tab === TOptions.league)
	{
		return <League />

	}

	return <></>

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export const Main = memo(main)


export default function (): JSX.Element
{
	let [tab, update_tab] = useState(TOptions.lister)

	let on_change = (v: TOptions): void =>
	{
		update_tab(v)

	}


	return (
		<>
			<Layout.Header
				breadcrumb={['项目管理', tab]}
				options={[TOptions.lister, TOptions.league]}
				change={on_change}
			/>

			<Layout.Main>
				<Main tab={tab} />

			</Layout.Main>

		</>

	)

}

export { default as View } from './components/view.tsx'
